
document.addEventListener('DOMContentLoaded', () => {
    const words = ["Site Web","Application Web","Application Desktop", "Application Mobile", "Systeme embarqué" ,"Graphic design"];
    let currentWordIndex = 0;
    const typingText = document.getElementById("typing-text");

    function typeWord() {
    typingText.textContent = "";
    const word = words[currentWordIndex];
    let i = 0;

    const interval = setInterval(() => {
        if (i < word.length) {
        typingText.textContent += word[i];
        i++;
        } else {
        clearInterval(interval);
        setTimeout(() => {
            currentWordIndex = (currentWordIndex + 1) % words.length;
            typeWord();
        }, 2000); // Attendre 2 secondes avant de passer au mot suivant
        }
    }, 100); // Vitesse de saisie (100 ms par caractère)
    }

    typeWord();
});
